import { useCallback, useSyncExternalStore } from 'react';

/** Q14 · the per-user "Show all screens" switch: a per-viewer convenience kept in localStorage (never required). */
const KEY = 'cpv.menu.showAll';
const listeners = new Set();

export function readShowAll() {
  try {
    return window.localStorage.getItem(KEY) === '1';
  } catch (e) {
    return false;
  }
}

export function writeShowAll(on) {
  try {
    window.localStorage.setItem(KEY, on ? '1' : '0');
  } catch (e) {
    /* storage blocked: the switch still works for this page view through the listeners below */
    memory = Boolean(on);
  }
  listeners.forEach((l) => l());
}

let memory = false;
const snapshot = () => readShowAll() || memory;
const subscribe = (l) => {
  listeners.add(l);
  window.addEventListener('storage', l);
  return () => {
    listeners.delete(l);
    window.removeEventListener('storage', l);
  };
};

/** [showAll, setShowAll]: the sidebar and the user menu share one value. */
export function useShowAllScreens() {
  const on = useSyncExternalStore(subscribe, snapshot, () => false);
  const set = useCallback((v) => {
    if (!v) memory = false;
    writeShowAll(v);
  }, []);
  return [on, set];
}
